export default __webpack_public_path__ + "static/media/arrow-right.e5f26d98.png";